import { useLocation } from "react-router-dom";
import Constants from "config/Constants";
import useHyroxTier from "hooks/useHyroxTier";

/** The Hyrox banners are upsells, so they only show to the tiers below T2, each on its own pages. */
function useHyroxBannerEligibility(visibleOnPages: string[]): boolean {
  const { isHyrox, isHyroxT0, isHyroxT1 } = useHyroxTier();
  const location = useLocation();

  if (!isHyrox) return false;
  if (!isHyroxT0 && !isHyroxT1) return false;

  return visibleOnPages.some((path) =>
    // Every pathname starts with "/", so the homepage only ever matches exactly
    path === Constants.routes.home.route ? location.pathname === path : location.pathname.startsWith(path)
  );
}

export default useHyroxBannerEligibility;
